'use strict';
import angular from 'angular';
import dayPartingHtmlUrl from './views/dayParting.html';

var app = angular.module('app.dayParting', []);

app.$inject = ['$ioAlert'];

app.component('dayParting', {
    bindings: {
        showActions: '=',
        dayPartingRanges: '='
    },
    templateUrl: dayPartingHtmlUrl,

    // The controller that handles our component logic
    controller: function($ioAlert) {
        var self = this;

        self.dayPartingObj = {};

        // Days Selection List
        // self.daysList = ["All days", "Monday - Friday", "Saturday - Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        self.daysList = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        self.hoursRange = [];
        self.twelveHourRanges = [
            {"value": "00:00", "label": "12:00 AM"},
            {"value": "00:15", "label": "12:15 AM"},
            {"value": "00:30", "label": "12:30 AM"},
            {"value": "00:45", "label": "12:45 AM"},
            {"value": "01:00", "label": "01:00 AM"},
            {"value": "01:15", "label": "01:15 AM"},
            {"value": "01:30", "label": "01:30 AM"},
            {"value": "01:45", "label": "01:45 AM"},
            {"value": "02:00", "label": "02:00 AM"},
            {"value": "02:15", "label": "02:15 AM"},
            {"value": "02:30", "label": "02:30 AM"},
            {"value": "02:45", "label": "02:45 AM"},
            {"value": "03:00", "label": "03:00 AM"},
            {"value": "03:15", "label": "03:15 AM"},
            {"value": "03:30", "label": "03:30 AM"},
            {"value": "03:45", "label": "03:45 AM"},
            {"value": "04:00", "label": "04:00 AM"},
            {"value": "04:15", "label": "04:15 AM"},
            {"value": "04:30", "label": "04:30 AM"},
            {"value": "04:45", "label": "04:45 AM"},
            {"value": "05:00", "label": "05:00 AM"},
            {"value": "05:15", "label": "05:15 AM"},
            {"value": "05:30", "label": "05:30 AM"},
            {"value": "05:45", "label": "05:45 AM"},
            {"value": "06:00", "label": "06:00 AM"},
            {"value": "06:15", "label": "06:15 AM"},
            {"value": "06:30", "label": "06:30 AM"},
            {"value": "06:45", "label": "06:45 AM"},
            {"value": "07:00", "label": "07:00 AM"},
            {"value": "07:15", "label": "07:15 AM"},
            {"value": "07:30", "label": "07:30 AM"},
            {"value": "07:45", "label": "07:45 AM"},
            {"value": "08:00", "label": "08:00 AM"},
            {"value": "08:15", "label": "08:15 AM"},
            {"value": "08:30", "label": "08:30 AM"},
            {"value": "08:45", "label": "08:45 AM"},
            {"value": "09:00", "label": "09:00 AM"},
            {"value": "09:15", "label": "09:15 AM"},
            {"value": "09:30", "label": "09:30 AM"},
            {"value": "09:45", "label": "09:45 AM"},
            {"value": "10:00", "label": "10:00 AM"},
            {"value": "10:15", "label": "10:15 AM"},
            {"value": "10:30", "label": "10:30 AM"},
            {"value": "10:45", "label": "10:45 AM"},
            {"value": "11:00", "label": "11:00 AM"},
            {"value": "11:15", "label": "11:15 AM"},
            {"value": "11:30", "label": "11:30 AM"},
            {"value": "11:45", "label": "11:45 AM"},
            {"value": "12:00", "label": "12:00 PM"},
            {"value": "12:15", "label": "12:15 PM"},
            {"value": "12:30", "label": "12:30 PM"},
            {"value": "12:45", "label": "12:45 PM"},
            {"value": "13:00", "label": "01:00 PM"},
            {"value": "13:15", "label": "01:15 PM"},
            {"value": "13:30", "label": "01:30 PM"},
            {"value": "13:45", "label": "01:45 PM"},
            {"value": "14:00", "label": "02:00 PM"},
            {"value": "14:15", "label": "02:15 PM"},
            {"value": "14:30", "label": "02:30 PM"},
            {"value": "14:45", "label": "02:45 PM"},
            {"value": "15:00", "label": "03:00 PM"},
            {"value": "15:15", "label": "03:15 PM"},
            {"value": "15:30", "label": "03:30 PM"},
            {"value": "15:45", "label": "03:45 PM"},
            {"value": "16:00", "label": "04:00 PM"},
            {"value": "16:15", "label": "04:15 PM"},
            {"value": "16:30", "label": "04:30 PM"},
            {"value": "16:45", "label": "04:45 PM"},
            {"value": "17:00", "label": "05:00 PM"},
            {"value": "17:15", "label": "05:15 PM"},
            {"value": "17:30", "label": "05:30 PM"},
            {"value": "17:45", "label": "05:45 PM"},
            {"value": "18:00", "label": "06:00 PM"},
            {"value": "18:15", "label": "06:15 PM"},
            {"value": "18:30", "label": "06:30 PM"},
            {"value": "18:45", "label": "06:45 PM"},
            {"value": "19:00", "label": "07:00 PM"},
            {"value": "19:15", "label": "07:15 PM"},
            {"value": "19:30", "label": "07:30 PM"},
            {"value": "19:45", "label": "07:45 PM"},
            {"value": "20:00", "label": "08:00 PM"},
            {"value": "20:15", "label": "08:15 PM"},
            {"value": "20:30", "label": "08:30 PM"},
            {"value": "20:45", "label": "08:45 PM"},
            {"value": "21:00", "label": "09:00 PM"},
            {"value": "21:15", "label": "09:15 PM"},
            {"value": "21:30", "label": "09:30 PM"},
            {"value": "21:45", "label": "09:45 PM"},
            {"value": "22:00", "label": "10:00 PM"},
            {"value": "22:15", "label": "10:15 PM"},
            {"value": "22:30", "label": "10:30 PM"},
            {"value": "22:45", "label": "10:45 PM"},
            {"value": "23:00", "label": "11:00 PM"},
            {"value": "23:15", "label": "11:15 PM"},
            {"value": "23:30", "label": "11:30 PM"},
            {"value": "23:45", "label": "11:45 PM"},
            ];

        self.twentyFourHourRanges = [
            {"value": "00:00", "label": "00:00"},
            {"value": "00:15", "label": "00:15"},
            {"value": "00:30", "label": "00:30"},
            {"value": "00:45", "label": "00:45"},
            {"value": "01:00", "label": "01:00"},
            {"value": "01:15", "label": "01:15"},
            {"value": "01:30", "label": "01:30"},
            {"value": "01:45", "label": "01:45"},
            {"value": "02:00", "label": "02:00"},
            {"value": "02:15", "label": "02:15"},
            {"value": "02:30", "label": "02:30"},
            {"value": "02:45", "label": "02:45"},
            {"value": "03:00", "label": "03:00"},
            {"value": "03:15", "label": "03:15"},
            {"value": "03:30", "label": "03:30"},
            {"value": "03:45", "label": "03:45"},
            {"value": "04:00", "label": "04:00"},
            {"value": "04:15", "label": "04:15"},
            {"value": "04:30", "label": "04:30"},
            {"value": "04:45", "label": "04:45"},
            {"value": "05:00", "label": "05:00"},
            {"value": "05:15", "label": "05:15"},
            {"value": "05:30", "label": "05:30"},
            {"value": "05:45", "label": "05:45"},
            {"value": "06:00", "label": "06:00"},
            {"value": "06:15", "label": "06:15"},
            {"value": "06:30", "label": "06:30"},
            {"value": "06:45", "label": "06:45"},
            {"value": "07:00", "label": "07:00"},
            {"value": "07:15", "label": "07:15"},
            {"value": "07:30", "label": "07:30"},
            {"value": "07:45", "label": "07:45"},
            {"value": "08:00", "label": "08:00"},
            {"value": "08:15", "label": "08:15"},
            {"value": "08:30", "label": "08:30"},
            {"value": "08:45", "label": "08:45"},
            {"value": "09:00", "label": "09:00"},
            {"value": "09:15", "label": "09:15"},
            {"value": "09:30", "label": "09:30"},
            {"value": "09:45", "label": "09:45"},
            {"value": "10:00", "label": "10:00"},
            {"value": "10:15", "label": "10:15"},
            {"value": "10:30", "label": "10:30"},
            {"value": "10:45", "label": "10:45"},
            {"value": "11:00", "label": "11:00"},
            {"value": "11:15", "label": "11:15"},
            {"value": "11:30", "label": "11:30"},
            {"value": "11:45", "label": "11:45"},
            {"value": "12:00", "label": "12:00"},
            {"value": "12:15", "label": "12:15"},
            {"value": "12:30", "label": "12:30"},
            {"value": "12:45", "label": "12:45"},
            {"value": "13:00", "label": "13:00"},
            {"value": "13:15", "label": "13:15"},
            {"value": "13:30", "label": "13:30"},
            {"value": "13:45", "label": "13:45"},
            {"value": "14:00", "label": "14:00"},
            {"value": "14:15", "label": "14:15"},
            {"value": "14:30", "label": "14:30"},
            {"value": "14:45", "label": "14:45"},
            {"value": "15:00", "label": "15:00"},
            {"value": "15:15", "label": "15:15"},
            {"value": "15:30", "label": "15:30"},
            {"value": "15:45", "label": "15:45"},
            {"value": "16:00", "label": "16:00"},
            {"value": "16:15", "label": "16:15"},
            {"value": "16:30", "label": "16:30"},
            {"value": "16:45", "label": "16:45"},
            {"value": "17:00", "label": "17:00"},
            {"value": "17:15", "label": "17:15"},
            {"value": "17:30", "label": "17:30"},
            {"value": "17:45", "label": "17:45"},
            {"value": "18:00", "label": "18:00"},
            {"value": "18:15", "label": "18:15"},
            {"value": "18:30", "label": "18:30"},
            {"value": "18:45", "label": "18:45"},
            {"value": "19:00", "label": "19:00"},
            {"value": "19:15", "label": "19:15"},
            {"value": "19:30", "label": "19:30"},
            {"value": "19:45", "label": "19:45"},
            {"value": "20:00", "label": "20:00"},
            {"value": "20:15", "label": "20:15"},
            {"value": "20:30", "label": "20:30"},
            {"value": "20:45", "label": "20:45"},
            {"value": "21:00", "label": "21:00"},
            {"value": "21:15", "label": "21:15"},
            {"value": "21:30", "label": "21:30"},
            {"value": "21:45", "label": "21:45"},
            {"value": "22:00", "label": "22:00"},
            {"value": "22:15", "label": "22:15"},
            {"value": "22:30", "label": "22:30"},
            {"value": "22:45", "label": "22:45"},
            {"value": "23:00", "label": "23:00"},
            {"value": "23:15", "label": "23:15"},
            {"value": "23:30", "label": "23:30"},
            {"value": "23:45", "label": "23:45"},
                
        ];

        self.hoursRange = self.twelveHourRanges;
        self.clockType = "twelve";
        
        // Function to switch time format from 12 hour to 24 hour
        self.changeTimeFormat = function(format) {
            if(format === 'twelve') {
                self.hoursRange = self.twelveHourRanges;
                self.clockType = "twelve";
            } else {
                self.hoursRange = self.twentyFourHourRanges;
                self.clockType = "twentyFour";
            }
        }

        // Function to validate the timeslots after submitting.
        self.submitDP = function() {
            var slotsValidation = true;
            _.each(self.dayPartingRanges.dayParts, function(dayPartObj,d_index){
                _.each(dayPartObj.slots, function(slotObj, s_index){
                    if(slotObj.start === slotObj.end) {
                        if(slotObj.start === "00:00" && slotObj.end === "00:00") {
                            slotsValidation = true;
                        } else {
                            slotsValidation = false;
                            $ioAlert.show('Error!', 'Start time and End time cannot be same', 'error');
                        }
                    }else if(slotObj.start > slotObj.end) {
                        slotsValidation = false;
                        $ioAlert.show('Error!', 'Start Time should come before End Time', 'error');
                    }else{
                        _.each(dayPartObj.slots, function(nextSlotObj, n_index){
                            if(s_index != n_index){
                                if(slotObj.start > nextSlotObj.start && slotObj.start < nextSlotObj.end){
                                    slotsValidation = false;
                                    $ioAlert.show('Error!', 'Start Time '+slotObj.start+' is overlap with other slots', 'error');
                                }
                                if(slotObj.end > nextSlotObj.start && slotObj.end < nextSlotObj.end){
                                    slotsValidation = false;
                                    $ioAlert.show('Error!', 'End Time '+slotObj.end+' is overlap with other slots', 'error');
                                }
                            }
                        });
                    }
                });
            });
            if(slotsValidation===false){
                return false;
            }
        }

        // Function to add New Timeslot
        self.addNewTime = function(currentItem){
            currentItem.slots.push(
                {"start": '00:00', "end": '00:00'}
            );
        }

        // Function to add another Day
        self.addNewRow = function () {
            self.dayPartingRanges.dayParts.push(
                 {  
                    "dayName": "Monday",
                    "slots": [
                        {"start": "00:00", "end": "00:00"}
                    ]
                }
            );
        }

        // Function to delete a timeslot
        self.deleteTimeSlot = function (slot, index, d_index) {
            if(self.dayPartingRanges.dayParts[d_index].slots.length === 1) {
                self.dayPartingRanges["dayParts"].splice(d_index, 1);
            } else {
                slot.slots.splice(index,1);
            }
        }

        // Function to Reset the Day Parting Widget
        self.resetComponent = function () {
            self.changeTimeFormat('twelve');
            self.dayPartingRanges = {
                "timeZoneType": "Publisher",
                "dayParts": [
                    {  
                        "dayName": "Monday",
                        "slots": [
                            {"start": "00:00", "end": "00:00"}
                        ]
                    }
                    
                ]
            };
        }

        // Initialize the component
        self.initComponent = function() {
            if(self.dayPartingRanges && !_.isEmpty(self.dayPartingRanges)){
                if(typeof self.dayPartingRanges == 'string') {
                    self.dayPartingRanges = JSON.parse(self.dayPartingRanges);
                }
                if(self.showActions){
                    self.showDayPartingView = false;
                    self.enableEditMode = true;
                }else {
                    self.showDayPartingView = true;
                    self.enableEditMode = false;
                }

            }else {
                self.dayPartingRanges = {
                    "timeZoneType": "Publisher",
                    "dayParts": [
                        {  
                            "dayName": "Monday",
                            "slots": [
                                {"start": "00:00", "end": "00:00"}
                            ]
                        }
                        
                    ]
                };
                self.showDayPartingView = false;
            }
        }

        self.initComponent();
    }
});